
import Vue from "vue";
import { Translation } from "@/utils/translation";
export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>Translation,
			required: true
		}
	}
});
